import styles from "./Page404.module.css";

import React from "react";

const LOGO_URL = "https://cloudfront.private-radar.com/img/logo/logo_login.png";

const IMG_ERROR_PATH = require("img/1error.jpg");

// error page when the user goes to worng URL, similar to Google 404 error
export default function Page404() {
	const path = window.location.pathname;
	return (
		<div className={styles.container}>
			<div className={styles.info}>
				<img src={LOGO_URL} alt="logo" className={styles.logo} />
				<p>
					<b>404. </b>
					<span className={styles.grey}>That's an error.</span>
				</p>
				<div>The requested URL {path} was not found on this server.</div>
				<div className={styles.grey}>That's all we know.</div>
			</div>
			<img src={IMG_ERROR_PATH} alt="error" className={styles.errorImg} />
		</div>
	);
}
